import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { formatPrice, CATEGORY_LABELS } from "@/lib/api";
import { useCart } from "@/context/CartContext";

const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();
  return (
  <motion.article
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-[#e8ded4] bg-white shadow-[0_2px_20px_rgba(75,58,47,0.06)] transition-shadow duration-500 hover:shadow-[0_20px_50px_rgba(75,58,47,0.15)]"
    data-testid={`product-card-${product.id}`}
  >
    <Link to={`/producto/${product.id}`} className="relative block aspect-[4/3] overflow-hidden bg-[#f2e9dd]">
      <img
        src={product.image_url}
        alt={product.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
      />
      <span className="absolute left-4 top-4 rounded-full bg-[#4b3a2f]/85 px-3 py-1 text-[11px] uppercase tracking-[0.14em] text-[#cdb79e] backdrop-blur-sm">
        {CATEGORY_LABELS[product.category] || product.category}
      </span>
      {product.featured && (
        <span className="absolute right-4 top-4 rounded-full bg-[#c9a24b] px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-[#4b3a2f]">
          Destacado
        </span>
      )}
    </Link>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="font-serif-d text-xl font-semibold leading-snug text-[#4b3a2f]">
        <Link to={`/producto/${product.id}`} className="gold-underline">
          {product.title}
        </Link>
      </h3>
      <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-[#6b5b52]">
        {product.short_description}
      </p>
      <div className="mt-4 flex items-center justify-between">
        <div>
          <p className="font-mono-d text-[10px] uppercase tracking-widest text-[#a47b52]">Desde</p>
          <p className="font-serif-d text-2xl font-semibold text-[#4b3a2f]">{formatPrice(product.price)}</p>
        </div>
        <button
          onClick={() => add(product)}
          data-testid={`add-to-cart-${product.id}`}
          aria-label="Agregar al carrito"
          className="flex h-11 w-11 items-center justify-center rounded-full bg-[#4b3a2f] text-[#f2e9dd] transition-all duration-300 hover:scale-110 hover:bg-[#c9a24b] hover:text-[#4b3a2f]"
        >
          <Plus size={18} strokeWidth={2.2} />
        </button>
      </div>
    </div>
  </motion.article>
  );
};

export default ProductCard;
